import { BeneficiaryCountry } from '@seapoint/server/enums';
import { getBeneficiaryCountryDetails } from '../../payments/utils/get-beneficiary-country-details';

type BillingAddress = {
  line1: string;
  line2?: string;
  postTown: string;
  postCode: string;
  country: BeneficiaryCountry;
};

export const formatBillingAddress = (address: BillingAddress): string => {
  const countryDetails = getBeneficiaryCountryDetails(address.country);

  const parts = [
    address.line1,
    address.line2,
    `${address.postTown} ${address.postCode}`.trim(),
    countryDetails.name,
  ].filter((part): part is string => Boolean(part));

  return parts.join(', ');
};
